import {useCallback, useState} from 'react'

export function useManualRender() {
  //we don't care about the value of the state, it is purely used to trigger a re-render
  const [_, setState] = useState({})
  // Triggers a re-render because the object literal will be a new object every time
  return useCallback(() => setState({}), [])
}
